<template>
    <BreadCrumb PageTitle="Liste des devoirs soumis" />
    <ListeDevoirs/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeDevoirs from "../../components/Devoir/ListeDevoirs.vue";

    export default defineComponent({
      name: "ListeDevoirsPage",
      components: {
        BreadCrumb,
        ListeDevoirs,
      },
    });
  </script>